// const new_service_basis = window.gtaAiConfig.service_basis
 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis
//  let service_data=getEnv(tag).service_data

export default {

    /**
     * 获取回收站文件类型
     */
    getComDictionary: `${new_service_basis}/ai/training/personlSpace/getComDictionary`,

    /**
     * 查询回收站首页列表数据
     */
    getRecycleList: `${new_service_basis}/ai/training/recycle/getRecycleList`,

    /**
     * 恢复回收站列表数据
     */
    recoveryRecycleData: `${new_service_basis}/ai/training/recycle/recoveryRecycleData`,
    /**
     * 解决重名冲突
     */
    solveDoubleName: `${new_service_basis}/ai/training/recycle/solveDoubleName`,
   /**
     * 彻底删除回收站数据
     */
   deleteRecycleData: `${new_service_basis}/ai/training/recycle/deleteRecycleData`,

};
